'use client'

import { format, isValid } from 'date-fns'

import { Button } from '@dc-shared-web/components/shadcn/button'
import { Calendar } from '@dc-shared-web/components/shadcn/calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@dc-shared-web/components/shadcn/popover'
import { cn } from '@dc-shared-web/lib'
import { DateRange } from 'react-day-picker'

export default function DateRangePicker({
  dateFrom,
  dateTo,
  onDateChange,
  trigger,
}: {
  dateFrom: Date | undefined
  dateTo: Date | undefined
  onDateChange: (from: Date | undefined, to: Date | undefined) => void
  trigger?: React.ReactElement
}) {
  const handleDateChange = (date: DateRange | undefined) => {
    onDateChange(date?.from, date?.to)
  }

  const getDateDisplay = (
    dateFrom: Date | undefined,
    dateTo: Date | undefined
  ) => {
    if (dateFrom && isValid(dateFrom)) {
      if (dateTo && isValid(dateTo)) {
        return `${format(dateFrom, 'LLL dd, y')} - ${format(
          dateTo,
          'LLL dd, y'
        )}`
      }
      return format(dateFrom, 'LLL dd, y')
    }
    return 'Add dates'
  }

  return (
    <Popover modal>
      <PopoverTrigger asChild>
        {trigger || (
          <Button
            id='date'
            variant={'ghost'}
            className={cn(
              'w-[280px] tw-justify-start tw-text-left tw-px-2 tw-py-1 tw-h-auto tw-text-neutral-700 tw-font-normal hover:tw-bg-neutral-100',
              !dateFrom &&
                !dateTo &&
                'tw-text-blue-600 hover:tw-text-blue-600 hover:tw-bg-transparent'
            )}
          >
            {getDateDisplay(dateFrom, dateTo)}
          </Button>
        )}
      </PopoverTrigger>
      <PopoverContent className='tw-w-auto tw-p-0' align='start'>
        <Calendar
          initialFocus
          mode='range'
          defaultMonth={dateFrom}
          selected={{ from: dateFrom, to: dateTo }}
          onSelect={handleDateChange}
          numberOfMonths={2}
        />
      </PopoverContent>
    </Popover>
  )
}
